<div class="card mb-2" *ngFor="let category of offboardingClient.offboardingCategoriesAndSteps">
  <div class="card-header line-item" (click)="onCategoryClick(category)">
    {{ category.description }}
    <ng-container *ngIf="category.isCompleted">
      <span class="icon-success far fa-circle-check"></span>
    </ng-container>
    <ng-container *ngIf="category.hasStarted && !category.isCompleted">
      <span class="icon-incomplete far fa-circle-question"></span>
    </ng-container>
  </div>

  <ng-container>
    <div class="card-body my-auto">
      <ul class="list-group list-group-light">
        <li
          class="list-group-item"
          *ngFor="let step of category.steps"
          [ngClass]="{
            'update-success': step.recentlyUpdated,
            'update-fail': step.error
          }"
        >
          <app-loading [busy]="step.isUpdating"></app-loading>
          <div class="d-sm-flex" style="justify-content: space-between">
            <ng-container *ngIf="!step.isUpdating">
              <div class="form-check line-item text-muted small">
                <input
                  class="form-check-input"
                  type="checkbox"
                  name="step_{{ step.id }}"
                  id="step_id_{{ step.id }}"
                  [(ngModel)]="step.isCompleted"
                  (change)="toggleStepUpdate(step)"
                />
                <label class="form-check-label" for="step_id_{{ step.id }}">{{ step.description }}</label>
              </div>
              <span *ngIf="step.error">
                <mdb-icon fas icon="circle-xmark" class="action-icon sortable" (click)="popupError(step.error)"></mdb-icon>
              </span>
            </ng-container>
          </div>
        </li>
      </ul>
    </div>
  </ng-container>
</div>
<error-component [error]="errorResponse" [(showModal)]="showError"></error-component>
